import { useEffect, useState } from "react";
import { getApp } from "firebase/app";
import {
  getStripePayments,
  getCurrentUserSubscriptions,
} from "@invertase/firestore-stripe-payments";
import { useAuth } from "../context/AuthContext";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const app = getApp();
const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "customers",
});

export function useIsPremium() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (!currentUser) {
      setIsPremium(false);
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const subs = await getCurrentUserSubscriptions(payments, {
          status: "active",
        });
        if (mounted) setIsPremium((subs || []).length > 0);
      } catch {
        if (mounted) setIsPremium(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [currentUser]);

  // Persist plan (free/premium) into user's profile for SuperAdmin reporting
  useEffect(() => {
    if (!currentUser || loading) return;
    const plan = isPremium ? "premium" : "free";
    setDoc(
      doc(db, "profilsUsers", currentUser.uid),
      { plan },
      { merge: true }
    ).catch(() => {});
  }, [isPremium, loading, currentUser]);

  return { isPremium, loading };
}
